const newsPicture = require('common/newsCarousel');

class purchasePic extends newsPicture {

}

module.exports = purchasePic;
